import { Box, Grid, Typography, useTheme } from '@mui/material'
import { EnhancedDropDownRHF } from '@websential/cosmic-v20'
import { Link } from 'react-router-dom';

import React from 'react'

interface IEarningSummaryHeaderPanel {
    payFrequencyDDLItems: { label: string, value: string }[];
    onFrequencyChangeHandler: (selected: any) => void
    payrollPeriodsDDL: { label: string, value: string }[];
    onPayrollPeriodsDDLChangeHandler: (selected: any) => void
    employeesDDL: { label: string, value: string }[];
    onEmployeeSelectionChangeHandler: (selected: any) => void
    formMethods: any;
}
export const EarningSummaryHeaderPanel: React.FC<IEarningSummaryHeaderPanel> = ({
    payFrequencyDDLItems,
    onFrequencyChangeHandler,
    payrollPeriodsDDL,
    onPayrollPeriodsDDLChangeHandler,
    employeesDDL,
    onEmployeeSelectionChangeHandler,
    formMethods,
}) => {
    const selectedPayFrequency = formMethods.watch("payFrequencyDDLItems");
    return (
        <>
            <Grid
                container
                size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                sx={{
                    background: "#fff",
                    padding: "15px",
                }}
                columnSpacing={2}
            >
                <Grid
                    size={{ xs: 12, sm: 12, md: 3, lg: 3, xl: 3 }}
                    sx={{ mt: "12px", "& .dropDownWrapper .dropDownField__menu": { zIndex: "999!important" } }}
                >
                    <EnhancedDropDownRHF
                        selectName="payFrequencyDDLItems"
                        testId={`payFrequencyDDLItems-list`}
                        items={payFrequencyDDLItems ?? []}
                        onSelectionChangeHandler={onFrequencyChangeHandler}
                    />
                  {selectedPayFrequency &&   <EnhancedDropDownRHF
                        selectName="payrollPeriodsDDL"
                        testId={`payrollPeriodsDDL`}
                        items={payrollPeriodsDDL ?? []}
                        onSelectionChangeHandler={onPayrollPeriodsDDLChangeHandler}
                    />}
                    {/* <ProcessPayrollDropDownRHF
                        selectName="payrollPeriodsDDL"
                        testId={`payrollPeriodsDDL`}
                        items={payrollPeriodsDDL ?? []}
                        onSelectionChangeHandler={onPayrollPeriodsDDLChangeHandler}
                    /> */}
                    {selectedPayFrequency && <EnhancedDropDownRHF
                        selectName="employee"
                        testId={`employee-list`}
                        items={employeesDDL ?? []}
                        onSelectionChangeHandler={onEmployeeSelectionChangeHandler}
                        showEmpty
                    />}
                </Grid>
                <Grid size={{ xs: 12, sm: 12, md: 1, lg: 1, xl: 1 }}> </Grid>
                {selectedPayFrequency && <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                    <span style={{ color: "rgb(88 83 83 / 58%)", fontSize: "0.875rem" }}>Employee ID 15</span>
                    <br />
                    <span style={{ color: "rgb(88 83 83 / 58%)", fontSize: "0.875rem" }}>Custom Employee ID 15</span>
                    <br />
                    <span style={{ color: "rgb(88 83 83 / 58%)", fontSize: "0.875rem" }}>Pay Period Ending Mar 31 2026</span>
                    <br />
                    <span style={{ color: "rgb(88 83 83 / 58%)", fontSize: "0.875rem" }}>Designation</span>
                    <br />
                    <span style={{ color: "rgb(88 83 83 / 58%)", fontSize: "0.875rem" }}>Department N/A</span>
                </Grid>}
            </Grid >
        </>
    )
}

